module.exports = __webpack_public_path__ + "static/media/1.f60ab950.svg";